<template>
  <div class="user-links">
    <Links :type="$store.getters.userType" />
    <TypeformPopup
      ref="enterpriseTypeform"
      :typeform-id="typeFormID"
      @typeFormSubmitted="typeFormSubmitted = $event" />
    <TypeFormThankYouPage
      v-if="showTypeFormThankYouPage"
      :is-pricing-page="false"
      @typeFormSubmitted="typeFormSubmitted = $event" />
  </div>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import getContext from '@/utilities/get-context';
import gtmEvents from '@/utils/gtmEvents';
import { dataLayerTrack } from '@/utils/datalayer';
import Cookies from 'js-cookie';
import {
  COOKIES,
  USER_LEAD_TYPE,
  TYPE_FORM_ID,
  USER_PLAN,
  USER_PLAN_URLS,
  UPGRADE_TO_PLAN_URLS,
  BUSINESS_CONTACT_FROM_URL,
  ANNUAL_BILLING_ID,
  ANNUAL_BILLING_ID_EUR,
  ANNUAL_BILLING_ID_GBP,
  YEARLY_AI_VOICEOVER_50K_BILLING_ID,
  YEARLY_AI_VOICEOVER_50K_BILLING_ID_EUR,
  YEARLY_AI_VOICEOVER_50K_BILLING_ID_GBP,
  YEARLY_AI_VOICEOVER_100K_BILLING_ID,
  YEARLY_AI_VOICEOVER_100K_BILLING_ID_EUR,
  YEARLY_AI_VOICEOVER_100K_BILLING_ID_GBP,
  YEARLY_AI_VOICEOVER_150K_BILLING_ID,
  YEARLY_AI_VOICEOVER_150K_BILLING_ID_EUR,
  YEARLY_AI_VOICEOVER_150K_BILLING_ID_GBP,
  YEARLY_AI_VOICEOVER_200K_BILLING_ID,
  YEARLY_AI_VOICEOVER_200K_BILLING_ID_EUR,
  YEARLY_AI_VOICEOVER_200K_BILLING_ID_GBP,
  TEAM_BILLING_ID,
  TEAM_BILLING_ID_EUR,
  TEAM_BILLING_ID_GBP,
  VO_AI_VOICEOVER_BUSINESS_USD_YEARLY,
  VO_AI_VOICEOVER_BUSINESS_EUR_YEARLY,
  VO_AI_VOICEOVER_BUSINESS_GBP_YEARLY,
  BUSINESS_BILLING_ID,
  YEARLY_TEMPLATES_ID,
  YEARLY_TEMPLATES_EUR,
  YEARLY_TEMPLATES_GBP,
  MONTHLY_TEMPLATES_ID,
  MONTHLY_TEMPLATES_EUR,
  MONTHLY_TEMPLATES_GBP,
  BUSINESS_PLAN_USD_YEARLY,
  BUSINESS_PLAN_EUR_YEARLY,
  BUSINESS_PLAN_GBP_YEARLY,
} from '@/constants';
import UserTrialLink from './user-trial-link';
import UserDropdown from './user-dropdown';
import TypeformPopup from '../../Plans/typeform-popup.vue';
import TypeFormThankYouPage from '../../TypeForm/thank-you-modal.vue';

function upgradePlanCTA(ctx, plan) {
  let btnShowFlag = false;
  let btnText = 'Upgrade';
  let btnPath = '';
  let btnTarget = '_self';
  let btnClickEventCb = () => {};
  const btnClass = ['ml-5 cta font-bold'];
  let isBusinessPlan = false;

  if (ctx?.parent?.$store?.getters?.hasContinuityPlan && !ctx?.injections?.hasHolidayPromo) {
    btnShowFlag = true;
    btnPath = '/pricing/';
    btnClickEventCb = () => {
      eventTracker(analyticsEvents.buttonClicked, {
        button_name: btnText,
        next_url: btnPath,
      });
    };
  } else if (
    ctx?.injections?.hasHolidayPromo &&
    ['monthly_unlimited_2020', 'monthly_maintenance_2020'].includes(plan?.toLowerCase())
  ) {
    btnShowFlag = true;
    btnPath = `/pricing/upgrade/${USER_PLAN_URLS[USER_PLAN.EVERYTHING_YEARLY]}/`;
    btnText = 'Upgrade Now';
    btnClickEventCb = () => {
      eventTracker(analyticsEvents.clickUpgrade, {
        flow: 'Special holiday sale promotion',
        button_name: btnText,
        next_url: btnPath,
        click_source: 'navigation bar',
      });
    };
  } else if (plan === 'monthly_unlimited_2020') {
    btnShowFlag = true;
    btnPath = `/pricing/upgrade/${USER_PLAN_URLS[USER_PLAN.EVERYTHING_YEARLY]}/`;
    btnClickEventCb = () => {
      eventTracker(analyticsEvents.clickUpgrade, {
        flow: ctx?.injections?.hasHolidayPromo ? 'Special holiday sale promotion' : '',
        button_name: btnText,
        next_url: btnPath,
        click_source: 'navigation bar',
      });
      eventTracker(analyticsEvents.buttonClicked, {
        button_name: btnText,
        next_url: btnPath,
      });
    };
  } else if (
    [
      ANNUAL_BILLING_ID,
      ANNUAL_BILLING_ID_EUR,
      ANNUAL_BILLING_ID_GBP,
      YEARLY_AI_VOICEOVER_50K_BILLING_ID,
      YEARLY_AI_VOICEOVER_50K_BILLING_ID_EUR,
      YEARLY_AI_VOICEOVER_50K_BILLING_ID_GBP,
      YEARLY_AI_VOICEOVER_100K_BILLING_ID,
      YEARLY_AI_VOICEOVER_100K_BILLING_ID_EUR,
      YEARLY_AI_VOICEOVER_100K_BILLING_ID_GBP,
      YEARLY_AI_VOICEOVER_150K_BILLING_ID,
      YEARLY_AI_VOICEOVER_150K_BILLING_ID_EUR,
      YEARLY_AI_VOICEOVER_150K_BILLING_ID_GBP,
      YEARLY_AI_VOICEOVER_200K_BILLING_ID,
      YEARLY_AI_VOICEOVER_200K_BILLING_ID_EUR,
      YEARLY_AI_VOICEOVER_200K_BILLING_ID_GBP,
      YEARLY_TEMPLATES_ID,
      YEARLY_TEMPLATES_EUR,
      YEARLY_TEMPLATES_GBP,
      MONTHLY_TEMPLATES_ID,
      MONTHLY_TEMPLATES_EUR,
      MONTHLY_TEMPLATES_GBP,
    ].includes(plan)
  ) {
    btnShowFlag = true;
    btnPath = `/pricing/upgrade/${USER_PLAN_URLS[USER_PLAN.EVERYTHING_YEARLY]}/`;
    btnClickEventCb = () => {
      eventTracker(analyticsEvents.clickUpgrade, {
        flow: ctx?.injections?.hasHolidayPromo ? 'Special holiday sale promotion' : '',
        button_name: btnText,
        next_url: btnPath,
        click_source: 'navigation bar',
      });
      eventTracker(analyticsEvents.buttonClicked, {
        button_name: btnText,
        next_url: btnPath,
      });
    };
  } else if ([TEAM_BILLING_ID, TEAM_BILLING_ID_EUR, TEAM_BILLING_ID_GBP].includes(plan)) {
    btnShowFlag = true;
    btnPath = `/pricing/upgrade/${UPGRADE_TO_PLAN_URLS[USER_PLAN.EVERYTHING_TEAMS]}/`;
    btnClickEventCb = () => {
      eventTracker(analyticsEvents.buttonClicked, {
        button_name: btnText,
        next_url: btnPath,
      });
    };
  } else if (
    [
      BUSINESS_BILLING_ID,
      VO_AI_VOICEOVER_BUSINESS_USD_YEARLY,
      VO_AI_VOICEOVER_BUSINESS_EUR_YEARLY,
      VO_AI_VOICEOVER_BUSINESS_GBP_YEARLY,
      BUSINESS_PLAN_USD_YEARLY,
      BUSINESS_PLAN_EUR_YEARLY,
      BUSINESS_PLAN_GBP_YEARLY,
    ].includes(plan)
  ) {
    btnShowFlag = true;
    btnText = 'Get More Credits';
    btnPath = BUSINESS_CONTACT_FROM_URL;
    btnTarget = '_blank';
    btnClickEventCb = () => {
      eventTracker(analyticsEvents.buttonClicked, {
        button_name: btnText,
        next_url: btnPath,
      });
    };
    isBusinessPlan = true;
  }

  return {
    btnShowFlag,
    btnText,
    btnPath,
    btnClass: btnClass.join(' '),
    btnTarget,
    btnClickEventCb,
    isBusinessPlan,
  };
}

export default {
  components: {
    TypeformPopup,
    TypeFormThankYouPage,
    Links: {
      functional: true,

      props: {
        type: {
          type: String,
          default: () => '',
        },
      },

      components: {
        UserDropdown,
        UserTrialLink,
      },

      inject: ['hasPromo', 'hasHolidayPromo', 'hasReferralCode'],

      render(h, ctx) {
        const trackNavigationClickEvent = (clickText, clickUrl) => {
          const eventData = {
            type: 'header',
            clickText,
            clickUrl,
          };
          eventTracker(analyticsEvents.navigationClick, eventData);
          dataLayerTrack({ eventName: gtmEvents.navigationClick, data: eventData });
        };

        const enterpriseClick = () => {
          trackNavigationClickEvent('Business', '/business/');

          eventTracker(analyticsEvents.buttonClicked, {
            button_name: 'Business',
            flow: 'enterprise form',
            next_url: 'https://motionarray.com/business/',
            click_source: 'navigation bar',
          });
        };

        const showReferralCtaButton = ctx.injections.hasReferralCode();

        const leadInfoJourney =
          ctx.parent.$store.state.user.leadInfoJourney ||
          Cookies.get(COOKIES.NAMES.LEAD_INFO_JOURNEY) ||
          [];
        const isPlOrSqlUser =
          leadInfoJourney?.includes(USER_LEAD_TYPE.PL) ||
          leadInfoJourney?.includes(USER_LEAD_TYPE.SQL);
        const showReferralIconToVisitor =
          ctx.parent.$store.getters.userType === 'visitor' && showReferralCtaButton;
        const showHolidayPromoIcon = ctx.injections.hasHolidayPromo && !showReferralIconToVisitor;

        let referralLink = null;
        let pricingBtn = null;

        const enterpriseButton = (
          <a
            onClick={enterpriseClick}
            class="text-b78"
            href="https://motionarray.com/business/"
            target="_blank">
            Business
          </a>
        );
        const borderSpace = <span class="ml-5 text-xl text-b80">|</span>;

        if (ctx.props.type === 'paid') {
          // TODO: EUR

          let upgradeBtn = null;
          const { plan } = getContext().__MA__.user;
          const {
            btnShowFlag,
            btnText,
            btnPath,
            btnClass,
            btnTarget,
            btnClickEventCb,
            isBusinessPlan,
          } = upgradePlanCTA(ctx, plan);

          if (btnShowFlag) {
            upgradeBtn = (
              <a href={btnPath} class={btnClass} target={btnTarget} onClick={btnClickEventCb}>
                {showHolidayPromoIcon && <i class="fa-solid fa-gift text-primary-purple mr-2" />}
                {btnText}
              </a>
            );
          }

          if (!upgradeBtn && !referralLink) {
            return [enterpriseButton, <UserDropdown />];
          }
          if (isBusinessPlan) {
            return [enterpriseButton, upgradeBtn, referralLink, <UserDropdown />];
          }
          return [enterpriseButton, borderSpace, upgradeBtn, referralLink, <UserDropdown />];
        }
        pricingBtn = (
          <a
            href="/pricing/"
            class="text-b78 whitespace-nowrap mx-4"
            onClick={() => {
              trackNavigationClickEvent('Pricing', '/pricing/');
            }}>
            {showReferralIconToVisitor && <i class="fa-solid fa-gift referral-gradient mr-2" />}
            Pricing
          </a>
        );

        if (ctx.props.type === 'free') {
          let upgradeBtn = null;
          if (showReferralCtaButton) {
            upgradeBtn = (
              <a
                href="/pricing/"
                class="ml-auto cta mr-4 font-bold"
                onClick={() => {
                  eventTracker(analyticsEvents.buttonClicked, {
                    flow: 'refer a friend',
                    button_name: 'Get 2 Extra Months',
                    next_url: '/pricing/',
                    click_source: 'navigation bar',
                  });
                }}>
                Get 2 Extra Months
              </a>
            );
          } else if (isPlOrSqlUser) {
            upgradeBtn = (
              <a
                class="ml-5 cta font-bold"
                onClick={() => {
                  ctx.parent.$refs?.enterpriseTypeform.toggle();
                  eventTracker(analyticsEvents.clickOnGetALicense, {
                    button_text: 'Contact Sales',
                    click_source: 'Nav bar',
                    component: 'Nav Bar',
                  });
                }}>
                Contact Sales
              </a>
            );
          } else {
            upgradeBtn = (
              <a
                href="/pricing/"
                class="ml-auto cta mr-4 font-bold"
                onClick={() => {
                  eventTracker(analyticsEvents.clickOnGetALicense, {
                    source: 'top nav',
                    button_name: 'Get a license',
                  });
                }}>
                {showHolidayPromoIcon && <i class="fa-solid fa-gift text-primary-purple mr-2" />}
                Subscribe Now
              </a>
            );
          }
          return [
            enterpriseButton,
            borderSpace,
            pricingBtn,
            upgradeBtn,
            referralLink,
            <UserDropdown />,
          ];
        }

        return [
          enterpriseButton,
          borderSpace,
          pricingBtn,
          <UserTrialLink />,
          <a
            href="/account/login/"
            class="flex items-center h-full whitespace-nowrap text-b78"
            onClick={evt => {
              evt.preventDefault();
              ctx.parent.$store.dispatch('setOpenSignInModal', {
                open: true,
                clickSource: 'main navigation',
                buttonName: 'Sign In',
              });
            }}>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                // eslint-disable-next-line max-len
                d="M12 .75C5.766.75.75 5.813.75 12c0 6.234 5.016 11.25 11.25 11.25 6.188 0 11.25-5.016 11.25-11.25C23.25 5.812 18.187.75 12 .75zM12 6c1.828 0 3.375 1.547 3.375 3.375 0 1.875-1.547 3.375-3.375 3.375a3.361 3.361 0 01-3.375-3.375C8.625 7.547 10.125 6 12 6zm0 14.25a8.203 8.203 0 01-6.281-2.86C6.609 15.985 8.156 15 9.984 15h3.985c1.828 0 3.375.984 4.265 2.39-1.547 1.782-3.75 2.86-6.234 2.86z"
                fill="currentColor"
              />
            </svg>

            <div style="margin-left: 8px;">Sign In</div>
          </a>,
        ];
      },
    },
  },
  data() {
    return {
      openTypeFormPopup: false,
      typeFormSubmitted: false,
    };
  },
  computed: {
    isPlOrSqlUser() {
      const leadInfoJourney = Cookies.get(COOKIES.NAMES.LEAD_INFO_JOURNEY);
      return (
        leadInfoJourney?.includes(USER_LEAD_TYPE.PL) ||
        leadInfoJourney?.includes(USER_LEAD_TYPE.SQL)
      );
    },
    typeFormID() {
      return this.isPlOrSqlUser ? TYPE_FORM_ID.PL_JOURNEY : TYPE_FORM_ID.ENTERPRISE;
    },
    showTypeFormThankYouPage() {
      return this.$store.state.user?.id && !this.openTypeFormPopup && this.typeFormSubmitted;
    },
  },
};
</script>

<style scoped>
.user-links {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.cta {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  height: 27px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 8px;
  @apply bg-primary-green text-primary-purple;

  font-size: 12px;
  cursor: pointer;
}
.referral-gradient {
  background: linear-gradient(180deg, #d40263 0%, #9555cd 100%);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}
</style>
